/* Ritual Lab · tema NORA — movimento (logotipo, revelar ao rolar, paralaxe). Sem dependências. */
(function () {
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  document.querySelectorAll('[data-split]').forEach(function (el) {
    var text = el.textContent.trim();
    el.setAttribute('aria-label', text);
    el.innerHTML = '<span class="rl-split-letters" aria-hidden="true">' +
      Array.from(text).map(function (ch, i) { return '<span style="--i:' + i + '">' + (ch === ' ' ? '&nbsp;' : ch) + '</span>'; }).join('') +
      '</span>';
  });
  requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-loaded'); }); });

  var els = document.querySelectorAll('[data-reveal], [data-curtain]');
  if (reduce || !('IntersectionObserver' in window) || root.classList.contains('shopify-design-mode')) {
    els.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) {
      var sibs = el.parentElement ? Array.from(el.parentElement.children).filter(function (c) { return c.hasAttribute('data-reveal'); }) : [];
      var i = sibs.indexOf(el);
      if (i > 0) el.style.transitionDelay = (i % 5) * 90 + 'ms';
      io.observe(el);
    });
  }

  var para = Array.from(document.querySelectorAll('[data-parallax]'));
  if (!reduce && para.length) {
    var ticking = false;
    var update = function () {
      para.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var speed = parseFloat(el.dataset.parallax) || 0.1;
        el.style.setProperty('--py', ((r.top + r.height / 2 - innerHeight / 2) * -speed).toFixed(1) + 'px');
      });
      ticking = false;
    };
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }
})();
